export interface TagItem {
  id: string;
  label: string;
}

export enum TagSize {
  EXTRA_SMALL = 'extraSmall',
  SMALL = 'small',
  MEDIUM = 'medium'
}
